export const toggleButton = (bool) => {
  return bool === true ? false : true;
};
